import React from "react";
import SummaryClasses from "./Referral.module.css";
function TaxSummary() {
    return (
        <div className={SummaryClasses["Container"]}>
            <div className={SummaryClasses["info"]}>
                <h3>Referral</h3>
                <table>
                    <thead>
                        <th>S.NO</th>
                        <th>Friend Name</th>
                        <th>Friend Email</th>
                        <th>Phone</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>01</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                {/* <button>Make Payment</button> */}
            </div>
        </div>
    );
}

export default TaxSummary;
